import { useEffect, useRef, useState } from 'react'
import type { ReactVirtualizer } from '@tanstack/react-virtual'

import type { Card } from '~/db/types'

import { MD_MEDIA_QUERY } from './const'
import type { ColumnCount } from './types'

export const useResponsiveColumnCount = (): ColumnCount => {
  const [columnCount, setColumnCount] = useState<ColumnCount>(() => (window.matchMedia(MD_MEDIA_QUERY).matches ? 1 : 2))

  useEffect(() => {
    const mediaQueryList = window.matchMedia(MD_MEDIA_QUERY)
    const onMediaQueryChange = () => setColumnCount(mediaQueryList.matches ? 2 : 1)

    onMediaQueryChange()
    mediaQueryList.addEventListener('change', onMediaQueryChange)

    return () => mediaQueryList.removeEventListener('change', onMediaQueryChange)
  }, [])

  return columnCount
}

export const useScrollToActiveCard = ({
  cards,
  rowVirtualizer,
  activeCardId,
}: {
  cards: Card[]
  rowVirtualizer: ReactVirtualizer<HTMLDivElement, Element>
  activeCardId?: string
}) => {
  const isExecutedRef = useRef(false)

  useEffect(() => {
    if (!cards.length || !activeCardId || isExecutedRef.current) return

    const activeCardIndex = cards.findIndex(card => card.id === activeCardId)
    if (activeCardIndex === -1) return

    rowVirtualizer.scrollToIndex(activeCardIndex, { align: 'center' })
    isExecutedRef.current = true
  }, [cards, activeCardId, rowVirtualizer])
}
